var React = require('react');

function MenuSolid (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("g",null,React.createElement("g",null,React.createElement("rect",{"y":"8","width":"64","height":"8"})))),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("g",null,React.createElement("rect",{"y":"48","width":"64","height":"8"})))),React.createElement("g",{"key":2},React.createElement("g",null,React.createElement("g",null,React.createElement("rect",{"x":"0","y":"28","width":"64","height":"8"}))))]));
}

MenuSolid.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 64 64","enableBackground":"new 0 0 0 0","xmlSpace":"preserve"};

module.exports = MenuSolid;

MenuSolid.default = MenuSolid;
